import axios, { AxiosError, AxiosResponse } from "axios";

import { IServiceResult, IUser, IUserProfile } from "../../Models/Models";
import { IUserProfileAxios } from "../IUserProfileAxios";
import { IOktaMFAFactor } from "../../Models/OktaModels/IOktaMFAFactor";
import { IUserShareSettings } from "../../Models/IUserShareSettings";

export class UserProfileAxios implements IUserProfileAxios {

    public DeleteUserAvatar(avatarStr: string): Promise<IServiceResult<boolean>> {
        return new Promise<IServiceResult<boolean>>((resolve, reject) => {
            axios
                .post<IServiceResult<boolean>>("/Users/DeleteProfileImage", {
                    avatarStr,
                })
                .then(
                    (response: AxiosResponse) => {
                        resolve(response.data);
                    },
                    (error: AxiosError) => {
                        reject(error);
                    }
                );
        });
    }

    public DeleteShareImage(shareStr: string): Promise<IServiceResult<boolean>> {
        return new Promise<IServiceResult<boolean>>((resolve, reject) => {
            axios
                .post<IServiceResult<boolean>>("/Users/DeleteShareImage", {
                    shareStr,
                })
                .then(
                    (response: AxiosResponse) => {
                        resolve(response.data);
                    },
                    (error: AxiosError) => {
                        reject(error);
                    }
                );
        });
    }

    public UpdateUserAvatar(avatarImg: File): Promise<IServiceResult<string>> {
        const formData: FormData = new FormData();
        formData.append("image", avatarImg);

        return new Promise<IServiceResult<string>>((resolve, reject) => {
            axios
                .post<IServiceResult<string>>(
                    "/Users/UpdateProfileImage",
                    formData,
                    {
                        headers: {
                            "content-type": "multipart/form-data",
                        },
                    }
                )
                .then(
                    (response: AxiosResponse) => {
                        resolve(response.data);
                    },
                    (error: AxiosError) => {
                        reject(error);
                    }
                );
        });
    }

    public UpdateShareImage(shareImg: File): Promise<IServiceResult<string>> {
        const formData: FormData = new FormData();
        formData.append("image", shareImg);

        return new Promise<IServiceResult<string>>((resolve, reject) => {
            axios
                .post<IServiceResult<string>>(
                    "/Users/UpdateShareImage",
                    formData,
                    {
                        headers: {
                            "content-type": "multipart/form-data",
                        },
                    }
                )
                .then(
                    (response: AxiosResponse) => {
                        resolve(response.data);
                    },
                    (error: AxiosError) => {
                        reject(error);
                    }
                );
        });
    }

    public UpdateUserProfile(
        userProfile: IUserProfile
    ): Promise<IServiceResult<IUser>> {
        return new Promise<IServiceResult<IUser>>((resolve, reject) => {
            axios
                .post<IServiceResult<IUser>>("/Account/UpdateUser", userProfile)
                .then(
                    (response: AxiosResponse) => {
                        resolve(response.data);
                    },
                    (error: AxiosError) => {
                        reject(error);
                    }
                );
        });
    }

    public ResetPassword(): Promise<IServiceResult<boolean>> {
        return new Promise<IServiceResult<boolean>>((resolve, reject) => {
            axios
                .post<IServiceResult<boolean>>("/Account/ResetPassword")
                .then(
                    (response: AxiosResponse) => {
                        resolve(response.data);
                    },
                    (error: AxiosError) => {
                        reject(error);
                    }
                );
        });
    }

    public GetMFAFactors(
        oktaUserId: string
    ): Promise<IServiceResult<IOktaMFAFactor[]>> {
        return new Promise<IServiceResult<IOktaMFAFactor[]>>(
            (resolve, reject) => {
                axios
                    .get<IServiceResult<IOktaMFAFactor[]>>(`/Users/GetMFAFactors?oktaUserId=${oktaUserId}`)
                    .then((response: AxiosResponse<IServiceResult<IOktaMFAFactor[]>>) => {
                        resolve(response.data);
                    })
                    .catch((error: AxiosError) => {
                        reject(error);
                    });
            }
        );
    }

  public IssueMFAChallenge = (factor: IOktaMFAFactor): Promise<boolean> => {
      return new Promise<boolean>((resolve, reject) => {
          axios
              .post(factor._links.verify.href)
              .then((response: AxiosResponse<boolean>) => {
                  resolve(response.data);
              })
              .catch((error: AxiosError) => {
                  reject(error);
              });
      });
  };

  public GetShareSettings = (): Promise<IServiceResult<IUserShareSettings>> => {
      return new Promise<IServiceResult<IUserShareSettings>>(
          (resolve, reject) => {
              axios
                  .get<IServiceResult<IUserShareSettings>>("/Users/GetShareSettings")
                  .then(
                      (response: AxiosResponse<IServiceResult<IUserShareSettings>>) => {
                          resolve(response.data);
                      }
                  )
                  .catch((error: AxiosError) => {
                      reject(error);
                  });
          }
      );
  };

  public UpdateShareSettings = (userShareSettings: IUserShareSettings): Promise<IServiceResult<IUserShareSettings>> => {
      return new Promise<IServiceResult<IUserShareSettings>>(
          (resolve, reject) => {
              axios
                  .post<IServiceResult<IUserShareSettings>>(
                      "/Users/UpdateShareSettings", userShareSettings)
                  .then(
                      (response: AxiosResponse<IServiceResult<IUserShareSettings>>) => {
                          resolve(response.data);
                      }
                  )
                  .catch((error: AxiosError) => {
                      reject(error);
                  });
          }
      );
  };
}
